/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pFooter.vue?vue&type=template&id=2205c4b3"
import script from "./pFooter.vue?vue&type=script&lang=js"
export * from "./pFooter.vue?vue&type=script&lang=js"
import style0 from "./pFooter.vue?vue&type=style&index=0&id=2205c4b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports